import React from "react";
import { Translate } from "react-localize-redux";
import ErrorBoundary from "../../components/errorBoundary/index.jsx";
import Loading from "../../components/loading/index.jsx";
import back from "./assets/images/back.png";
import "./assets/styles/subPage.sass";
import Sidebar from "./sidebarMenu.jsx";

export default class SubPage extends ErrorBoundary {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			loading: false,
			showHeader: true,
			showSidebar: true,
		};
	}

	toggleLoading(loading = false) {
		this.setState({ loading });
	}

	getPageContent() {
		return;
	}

	getPageHeader() {
		return;
	}

	goBack = () => {
		this.props?.history?.goBack();
	};

	renderBody() {
		const { showHeader, showSidebar } = this.state;
		const { location } = this.props;
		const isInboxPage = location?.pathname === "/profile/inbox";
		return (
			<Translate>
				{({ translate }) => (
					<div className={`profile-page-wrapper ${isInboxPage}`}>
						{this.state.loading && <Loading loading={true} />}
						{showSidebar && <Sidebar activePage={"changePassword"} />}
						<div className="profile-page-content">
							{showHeader && (
								<div className="sub-page-header">
									<div
										className="mobile-back"
										onClick={this.goBack}>
										<img src={back} /> {translate("BACK")}
									</div>
									{this.getPageHeader(translate)}
								</div>
							)}
							<div className="sub-page-content">{this.getPageContent(translate)}</div>
						</div>
					</div>
				)}
			</Translate>
		);
	}
}
